import React from 'react'
import { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { useLoading } from '../../../context/LoadingContext';
import { CiEdit } from "react-icons/ci";

function Matrerial_issuee_Production({ branchID }) {

  const { setLoading } = useLoading();
  const [showForm, setShowForm] = useState(false);


  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };
  const [isEditMode, setIsEditMode] = useState(false);
  const [items, setItems] = useState([]);
 const [inventoryItems, setInventoryItems] = useState([]);
  const [bom, setBom] = useState([]);
  const [godownOptions, setGodownOptions] = useState([]);
  const [batch, setBatch] = useState([]);
  const [batchOptions, setBatchOptions] = useState([]);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [production, setFetchProduction] = useState([]);
  const [branchDetail, setBranchDetail] = useState([])
   const [searchTerm, setSearchTerm] = useState('');

  const [formData, setFormData] = useState({
    product: '',
    qty: '',
    actual_production: '',
    production_date: '',
    pc: '',
    cost: '',
    godown: '',
    batch: '',
    total_cost: '',
    remark: '',

    tableRow: [{ item: "", qty: "", rate: '', stock: '', godown: null, batch: null, }],

    added_by: '',
    edit_by: '',
  })

  const handleAddClick = () => {
    setShowForm(true);
  }


 

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      if (name === "qty") {
        const prodQty = Number(value);

        updated.tableRow = prev.tableRow.map(row => {
  
          const baseQty = row.qtyOriginal ?? row.qty ?? 0;

  
          if (!isNaN(prodQty) && value !== "" && prodQty > 0) {
            return { ...row, qty: baseQty * prodQty, qtyOriginal: baseQty };
          }

   
          return row;
        });
      }


      updated.total_cost = calculateTotalCost(updated.tableRow);

      if (name === "actual_production") {
        const actualProd = Number(value);
        if (actualProd > 0) {
          updated.cost = (Number(updated.total_cost) / actualProd).toFixed(2);
        } else {
    
          updated.cost = prev.cost || 0;
        }
      }

      return updated;
    });
  };




  const addRow = () => {
    setFormData(prev => ({
      ...prev,
      tableRow: [...prev.tableRow, { item: "", qty: "" }]
    }));
  };

  const deleteRow = (index) => {
    setFormData(prev => ({
      ...prev,
      tableRow: prev.tableRow.filter((_, i) => i !== index)
    }));
  };


  const handleUpdate = async (e) => {
    e.preventDefault();

    const payload = {
      product: formData.product,
      qty: formData.qty,
      actual_production: formData.actual_production,
      production_date: formData.production_date,

      pc: formData.pc,
      cost: formData.cost,
      godown: formData.godown,
      batch: formData.batch,
      total_cost: formData.total_cost,
      remark: formData.remark,

      items: formData.tableRow.map(row => ({
        item: row.item,
        qty: row.qty ?? 0,
        rate: row.rate,
        stock: row.stock,
        batch: row.batch,
        godown: row.godown
      })),
    };

    try {



      if (isEditMode && editingCompanyId) {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-production/${editingCompanyId}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      } else {

        const res = await axios.post(
          "https://api.skyguard.group/api/add-production",
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
      }


      fecthProduction();
      resetForm();
      showToast(
        isEditMode
          ? "Production Updated Successfully!"
          : "Production Added Successfully!",
        "success"
      );

      setShowForm(false)
    } catch (err) {
      console.error(err);
      alert("Failed to save");
    }
  };

  const handleRowChange = (idx, updatedRow) => {
    const updatedTable = [...formData.tableRow];
    updatedTable[idx] = updatedRow;

    setFormData(prev => ({
      ...prev,
      tableRow: updatedTable,
      total_cost: calculateTotalCost(updatedTable)
    }));
  };


  const handleEdit = (form) => {


    const parsedProduct =
      form.product && typeof form.product === "string"
        ? JSON.parse(form.product)
        : form.product;

    const parsedItems =
      form.items && typeof form.items === "string"
        ? JSON.parse(form.items)
        : [];



    const date = new Date(form.production_date);
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");




    setFormData({
      id: form.id,
      product: parsedProduct,
      qty: form.qty ?? 0,
      actual_production: form.actual_production ?? "",

      production_date: `${yyyy}-${mm}-${dd}T${hh}:${min}`,
      pc: form.pc ?? "",
      cost: form.cost ?? "",
      godown: form.godown ?? null,
      batch: form.batch ? Number(form.batch) : null,

      batch_no: form.batch_no ?? "",
      total_cost: form.total_cost ?? "",
      remark: form.remark ?? "",
      tableRow: parsedItems.map(row => ({
        item: row.item,
        qty: row.qty ?? "",
        rate: row.rate ?? 0,
        stock: row.stock ?? 0,
        batch: row.batch ?? null,
        godown: row.godown ?? null,
      })),
    });


    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };


  const resetForm = () => {
    setFormData({
      product: '',
      qty: '',
      actual_production: '',
      production_date: '',
      pc: '',
      cost: '',
      godown: '',
      batch_no: '',
      total_cost: '',
      remark: '',

      tableRow: [{ item: "", qty: "", rate: '', stock: '', godown: null, batch: null, }]
    });
  };


  const fecthDetail = async () => {
    try {
      const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
      const items = resInventory.data.result || [];

      const options = items.map(item => ({
        value: item.id,
        label: item.name
      }));


      setInventoryItems(options);
      // setProductOptions(options);
    } catch (error) {
      console.log(error)
    }
  };

  const fecthBomDetail = async () => {
    setLoading(true);
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-bom");

      const parsedData = res.data.map(bom => ({
        ...bom,
        product: typeof bom.product === "string" ? JSON.parse(bom.product) : bom.product,
        items: typeof bom.items === "string" ? JSON.parse(bom.items) : bom.items,
      }));

      setBom(parsedData);
      console.log(parsedData);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };




  const fetchGodown = async () => {
    try {
      const result = await axios.get('https://api.skyguard.group/api/fetch-godown');
      const godowns = result.data || [];

      const options = godowns.map(g => ({
        value: g.id,
        label: g.godown_name
      }));

      setGodownOptions(options);
    } catch (error) {
      console.log(error);
    }
  };





  const fetchBatchDetail = async () => {
    setLoading(true);
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-batch');
      const batches = res.data || [];


      const options = batches.map(b => ({
        value: b.id,
        label: b.batch_no
      }));

   

      setBatchOptions(options);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };


  const fetchBranchDetail = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);


      setBranchDetail(res.data)


    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const prodQty = Number(formData.qty);

    if (formData.tableRow.length > 0) {
      const updatedTable = formData.tableRow.map(row => {

        if (!isNaN(prodQty) && prodQty > 0) {
          return { ...row, qty: (row.qtyOriginal ?? row.qty ?? 0) * prodQty };
        }

        return { ...row };
      });

      setFormData(prev => ({ ...prev, tableRow: updatedTable }));
    }
  }, [formData.qty]);




  const fecthProduction = async () => {
    setLoading(true)
    try {
      const res = await axios.get('https://api.skyguard.group/api/fetch-production');

      setFetchProduction(res.data);

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {

    fecthDetail();
    fecthBomDetail();
    fetchGodown();
    fetchBatchDetail();
    fecthProduction();
    fetchBranchDetail();
  }, []);

  const productOptions = bom.map(b => ({
    value: b.product.id,
    label: b.product.name
  }));

  const handleProductSelect = (selected) => {

    const selectedBOM = bom.find(b => b.product.id === selected.value);

    setFormData({
      ...formData,
      product: selected,
      tableRow: selectedBOM?.items.map(it => ({
        item: it.item,
        qty: it.qty || '',
        rate: it.rate || '',
        stock: it.stock || ''
      })) || []
    });
  };

  const calculateTotalCost = (tableRows) => {
    return tableRows.reduce((sum, row) => {
      const qty = Number(row.qty) || 0;
      const rate = Number(row.rate) || 0;
      return sum + qty * rate;
    }, 0);
  };


  const formatDate = (date) => {
    if (!date) return "";      

    const d = new Date(date);
    if (isNaN(d)) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };


const filterBatch = production.filter((tt) => {
  const term = searchTerm.toLowerCase();

  // Safely parse product JSON
  let productLabel = "";
  try {
    const productObj = typeof tt.product === "string" ? JSON.parse(tt.product) : tt.product;
    productLabel = productObj?.label?.toLowerCase() || "";
  } catch (err) {
    productLabel = "";
  }

  return (
    (tt.batch_no && tt.batch_no.toLowerCase().includes(term)) ||
    (productLabel && productLabel.includes(term))
  );
});


  return (
    <div className='main-section'>
      <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />

      <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
        <h3 className='my-3 fw-bold fs-5 golos'>Material Issue And Production</h3>
        <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
          <div class="col-12 col-md-4">
            <input
              type="text"
              class="form-control"
              id="searchInput"
              placeholder="Search by Product Name,Batch No...."
                   value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="col-12 col-md-2 d-flex justify-content-end">
            <button className='btn btn-success' onClick={handleAddClick} >
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>


        {showForm && (
          <form onSubmit={handleUpdate}>


            <div className='card p-3 my-3 shadow-sm bg-white border'>
              <div className='row'>


                {/* left */}
                <div className='col-md-6'>
                  <div className="row g-3">

                    <div className="col-12 ">
                      <label className="form-label fw-medium">Product</label>
                      <Select
                        options={productOptions}
                        value={formData.product || null}
                        placeholder="Select product"
                        onChange={handleProductSelect}
                        className="w-100"
                      />
                    </div>

                    <div className="col-12 ">
                      <label className="form-label fw-medium">Godown</label>
                      <Select
                        options={godownOptions}
                        value={godownOptions.find(opt => opt.value === formData.godown) || null}
                        placeholder="Select Godown"
                        onChange={(selected) => {
                          setFormData(prev => ({ ...prev, godown: selected.value }));
                        }}
                      />
                    </div>



                    <div className="col-12 ">
                      <label className="form-label fw-medium">Batch No.</label>
                      <Select
                        options={batchOptions}
                        value={batchOptions.find(opt => opt.value === formData.batch) || null}
                        placeholder="Select Batch"
                        onChange={(selected) => {
                          setFormData(prev => ({ ...prev, batch: selected.value }));
                        }}
                      />
                    </div>


                    <div className="col-12 ">
                      <label className="form-label fw-medium">Production QTY </label>
                      <input
                        type="text"
                        className="form-control"
                        name="qty"
                        value={formData.qty}
                        onChange={handleChange}
                        required
                      />
                    </div>


                  </div>
                </div>

                {/* Right */}
                <div className='col-md-6'>
                  <div className="row g-3">
                    <div className="col-12 ">
                      <label className="form-label fw-medium">Production Date </label>
                      <input
                        type="datetime-local"
                        className="form-control"
                        name="production_date"
                        value={formData.production_date}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-12 ">
                      <label className="form-label fw-medium">Actual Production </label>
                      <input
                        type="text"
                        className="form-control"
                        name="actual_production"
                        value={formData.actual_production}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12 ">
                      <label className="form-label fw-medium">Cost/Unit </label>
                      <input
                        type="text"
                        className="form-control"
                        name="cost"
                        value={formData.cost}
                        onChange={handleChange}
                      />
                    </div>



                  </div>
                </div>


                <div className='col-12'>
                  <div className='row g-3'>








                    <div className="table-responsive my-4">


                      <div className="col-12 col-md-1 mb-2 d-flex justify-content-start justify-content-md-end">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          onClick={addRow}
                        >
                          + Add
                        </button>
                      </div>

                      <table className="table table-bordered mx-auto text-center align-middle ">
                        <thead className="table-primary">
                          <tr>
                            <th>Item Name</th>
                            <th>Req Qty</th>
                            <th>Avil Qty</th>

                            <th>Item Rate</th>
                            {/* <th>PCs</th> */}
                            <th>Item Batch No</th>
                            <th>Item Godown</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>




                          {formData?.tableRow.map((row, idx) => {

                            const selectedItem = inventoryItems.find(i => i.value === row.item);

                            return (
                              <tr key={idx}>
                                {/* Item Select */}
                                <td>
                                  <Select
                                    options={inventoryItems}
                                    value={selectedItem || null}
                                    placeholder="Select Item"
                                    onChange={(selected) => {
                                      const updated = [...formData.tableRow];
                                      const itemDetails = inventoryItems.find(i => i.value === selected.value);

                                      updated[idx] = {
                                        ...updated[idx],
                                        item: selected.value,
                                        rate: itemDetails?.rate ?? 0,
                                        stock: itemDetails?.stock ?? 0,

                                        qtyOriginal: updated[idx]?.qtyOriginal ?? updated[idx]?.qty ?? 0,
                                      };

                                      setFormData(prev => ({ ...prev, tableRow: updated }));
                                    }}
                                       menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                  />
                                </td>

                                {/* Qty input */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={row.qty}
                                    onChange={(e) => {
                                      const value = Number(e.target.value);

                                      const updatedRow = {
                                        ...row,
                                        qtyOriginal: value,
                                        qty: value * (Number(formData.qty) || 1)
                                      };

                                      handleRowChange(idx, updatedRow);
                                    }}
                                  />



                                </td>

                                {/* Stock (readonly) */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={row.stock ?? selectedItem?.stock}
                                    readOnly
                                  />
                                </td>

                                {/* Rate (readonly) */}
                                <td>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    value={row.rate ?? selectedItem?.rate ?? 0}
                                    readOnly
                                  />
                                </td>


                                <td>
                                  <Select
                                    options={batchOptions}
                                    value={
                                      batchOptions.find(opt => opt.value === row.batch) || null
                                    }
                                    placeholder="Select Batch"
                                    onChange={(selected) => {
                                      const updated = [...formData.tableRow];
                                      updated[idx].batch = selected.value;

                                      setFormData(prev => ({
                                        ...prev,
                                        tableRow: updated
                                      }));
                                    }}
                                       menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                  />
                                </td>

                                <td>
                                  <Select
                                    options={godownOptions}
                                    value={
                                      godownOptions.find(opt => opt.value === row.godown) || null
                                    }
                                    placeholder="Select Godown"
                                    onChange={(selected) => {
                                      const updated = [...formData.tableRow];
                                      updated[idx].godown = selected.value;

                                      setFormData(prev => ({
                                        ...prev,
                                        tableRow: updated
                                      }));
                                    }}
                                       menuPortalTarget={document.body}
                                styles={{
                                  container: base => ({ ...base, width: "100%" }),
                                  menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}
                                  />
                                </td>


                                {/* Delete button */}
                                <td className="text-center">
                                  <button type="button" className="btn btn-danger btn-sm"
                                    onClick={() => deleteRow(idx)}
                                  >
                                    <AiOutlineDelete size={22} />
                                  </button>
                                </td>
                              </tr>
                            )
                          })}

                        </tbody>
                      </table>
                    </div>


                    <div className="col-12 col-md-6">
                      <label className="form-label fw-medium">Total Cost</label>
                      <input
                        type="number"
                        className="form-control"
                        name="total_cost"
                        value={formData.total_cost}
                        onChange={handleChange}
                      />

                    </div>

                    <div className='row' >
                      <div className="col-12 col-md-6">
                        <label className="form-label fw-medium">Remark</label>
                        <textarea type="text"
                          className="form-control"
                          rows="3"
                          name="remark"
                          value={formData.remark}
                          onChange={handleChange}>

                        </textarea>


                      </div>
                    </div>

                  </div>
                </div>




                <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                  <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                  <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                </div>
              </div>
            </div>


          </form>
        )}


        <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
          <table className='table table-bordered table-striped table-hover text-center align-middle'>
            <thead className='table-info'>
              <tr>
                     <th scope='col' >Action</th>
                <th scope='col' >Ref Doc </th>

                <th scope='col'>Product Name</th>
                <th scope='col' >Batch No. </th>
                <th scope='col' >Production Date </th>

           
              </tr>
            </thead>
            <tbody>
              {filterBatch.length > 0 ? (
                filterBatch.map((item, index) => (
                  <tr key={index}>
                    {/* <td>{index + 1}  </td> */}
                            <td>  <button
                      className="btn btn-warning"

                      onClick={() => handleEdit(item)}
                    >
                      <CiEdit size={20} />
                    </button>
                    </td>
                    <td>{`PRD/${item.id}/${branchDetail.code}`}</td>
                    <td>{JSON.parse(item.product).label}</td>

                    <td>{item.batch_no} </td>
                    <td>{formatDate(item.production_date)} </td>

            
                  </tr>
                ))) : (
                <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                </tr>
              )}
            </tbody>

          </table>
        </div>

      </div>

    </div>
  )
}

export default Matrerial_issuee_Production